// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Label from '../../../components/label';
import Iconify from '../../../components/iconify';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Menu',
    items: [
      { title: 'Lowongan Pekerjaan', path: PATH_DASHBOARD.joblist.list, icon: ICONS.dashboard },      
      { title: 'Pipeline', path: PATH_DASHBOARD.pipeline.list, icon: ICONS.analytics },
      { title: 'Pendidikan', path: PATH_DASHBOARD.education.list, icon: ICONS.mail },
      { title: 'Pengalaman Kerja', path: PATH_DASHBOARD.experience.list, icon: ICONS.calendar },
      { title: 'Dokumen', path: PATH_DASHBOARD.applicantfile.list, icon: ICONS.folder },
    ],
  },
];

export default navConfig;
